export default "__VITE_ASSET__B2gSusO6__"